import { v4 as uuidv4 } from 'uuid';
export class EngagementActivityModel {
    constructor() {
        this.activityId = uuidv4();
        this.activityDesc = '';
        this.isTenantVisible = false;
        this.isDone = false;
        this.markedDoneBy = '';
        this.markedDoneOn = '';
        this.baseline = 0;
        this.actuals = 0;
        this.threshold = 0;
        this.notes = '';
        this.docs = [];
        this.actions = [];
    }
}
export class EngagementActivity extends EngagementActivityModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
    get notesCount() {
        return this.notes.length;
    }
    get docsCount() {
        return this.docs.length;
    }
    get actionsCount() {
        return this.actions.length;
    }
}
